var r = /* @__PURE__ */ ((n) => (n.ACTIVE = "active", n.PASSIVE = "passive", n.HIDDEN = "hidden", n.FROZEN = "frozen", n.TERMINATED = "terminated", n.UNKNOWN = "unknown", n))(r || {});
export {
  r as LifecycleState
};
//# sourceMappingURL=usePageLifecycle.enums.mjs.map
